import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const CareerAll = () => {
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const [allCareer, setAllCareer] = useState([]);

  // Fetch all careers
  useEffect(() => {
    fetchAllCareers();
  }, []);

  const fetchAllCareers = () => {
    axios
      .get(`${API_BASE_URL}/careerCategories`)
      .then((response) => {
        setAllCareer(response.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching careers:", error);
      });
  };

  const handleAddNewCareer = () => {
    navigate("/add-career");
  };

  const handleViewAllCareer = () => {
    navigate("/all-career");
  };

  const handleEdit = (id) => {
    navigate(`/edit-career/${id}`);
  };

  const handleDelete = (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this career?"
    );

    if (confirmDelete) {
      axios
        .delete(`${API_BASE_URL}/admin/careerCategories/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          alert("Career deleted successfully");
          console.log("Career deleted successfully:", response.data);

          // Fetch the updated list of careers
          fetchAllCareers();
        })
        .catch((error) => {
          console.error("Error deleting career:", error);
        });
    }
  };

  return (
    <>
      <div id="add-subject-inner-wrapper">
        <div className="superheader">
          <div className="subjectHeaderdiv">
            <h5>Career</h5>
            <div className="subjectdiv2">
              <button className="handleNewSubject" onClick={handleAddNewCareer}>
                + Add New Career
              </button>
              <button className="allSubjects" onClick={handleViewAllCareer}>
                All Career
              </button>
            </div>
          </div>

          <div className="classes-table-container">
            <h5>All Career</h5>
            <table className="classes-table">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Title</th>
                  <th>Description</th>
                  <th>Image</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {allCareer.length > 0 ? (
                  allCareer.map((item, idx) => (
                    <tr key={item._id}>
                      <td>{idx + 1}</td>
                      <td>{item.name}</td>
                      <td>{item.description}</td>
                      <td>
                        <img
                          src={`${API_BASE_URL}/uploads/${item.careerImg}`}
                          alt="Career"
                          className="w-50"
                        />
                      </td>
                      <td className="table-action-icons d-flex gap-2">
                        <i
                          className="fa-solid fa-file-pen"
                          onClick={() => handleEdit(item._id)}
                        ></i>
                        &nbsp;&nbsp;
                        <i
                          className="fa-solid fa-trash-can"
                          onClick={() => handleDelete(item._id)}
                        ></i>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      <h4>No data found</h4>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default CareerAll;
